var validName = function validName(_a) {
  var _b = _a.namePart,
    namePart = _b === void 0 ? 'Имя' : _b,
    _c = _a.allowSpaces,
    allowSpaces = _c === void 0 ? false : _c;
  return function (value) {
    if (!value) {
      return;
    }
    if (value.length > 50) {
      return namePart + " \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C 50 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432";
    }
    if (value.length === 1 && /[^а-яё]+/i.test(value)) {
      return namePart + " \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0437 \u043E\u0434\u043D\u043E\u0433\u043E \u0441\u0438\u043C\u0432\u043E\u043B\u0430";
    }
    if (/\d+/.test(value)) {
      return namePart + " \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0446\u0438\u0444\u0440\u044B";
    }
    var withSpaces = /^([а-яё\-'`]+ )*[а-яё\-'`]+$/gim;
    var noSpaces = /^([а-яё\-'`])+$/gim;
    var regex = allowSpaces ? withSpaces : noSpaces;
    return !value.match(regex) ? namePart + " \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B" : undefined;
  };
};
export { validName };